import { useEffect, useState } from "react";

export type ViewPortState = {
  readonly height?: number;
  readonly offsetLeft?: number;
  readonly offsetTop?: number;
  readonly pageLeft?: number;
  readonly pageTop?: number;
  readonly scale?: number;
  readonly width?: number;
};
export function useVisualViewport(): ViewPortState {
  const [viewport, setViewport] = useState<ViewPortState>({});

  useEffect(() => {
    const vv = window.visualViewport;
    if (!vv) {
      return;
    }

    const update = () => {
      setViewport({
        height: vv.height,
        offsetLeft: vv.offsetLeft,
        offsetTop: vv.offsetTop,
        pageLeft: vv.pageLeft,
        pageTop: vv.pageTop,
        scale: vv.scale,
        width: vv.width,
      });
    };

    update();
    // eslint-disable-next-line unicorn/prefer-observer-apis -- will address this later
    vv.addEventListener("resize", update);
    // eslint-disable-next-line unicorn/prefer-observer-apis -- will address this later
    vv.addEventListener("scroll", update);
    globalThis.addEventListener("orientationchange", update);

    return () => {
      vv.removeEventListener("resize", update);
      vv.removeEventListener("scroll", update);
      globalThis.removeEventListener("orientationchange", update);
    };
  }, []);

  return viewport;
}
